import axios, { AxiosInstance } from 'axios'
import { AUTH_CONFIG } from '../constants/app.constants'
import { normalizeError, logError } from '../utils/error.utils'

export interface LoginPayload {
  username: string
  password: string
}

export interface LoginResponse {
  status?: boolean
  token?: string
  access_token?: string
  token_type?: string
  refresh_token?: string
  expires_in?: number
  expiry?: number
  user?: Record<string, any>
  [key: string]: any
}

class AuthService {
  private client: AxiosInstance

  constructor() {
    this.client = axios.create({
      baseURL: AUTH_CONFIG.BASE_URL,
      timeout: AUTH_CONFIG.TIMEOUT,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  }

  async login(payload: LoginPayload): Promise<LoginResponse> {
    try {
      // Convert payload to form-encoded format
      const formData = new URLSearchParams()
      formData.append('username', payload.username)
      formData.append('password', payload.password)

      // Make request with form-encoded content type and required headers
      const response = await this.client.post<LoginResponse>(
        AUTH_CONFIG.LOGIN_ENDPOINT,
        formData.toString(),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache',
            'os': 'web',
            'language': 'en',
          },
        }
      )
      const data = response.data as LoginResponse & { data?: LoginResponse }
      const normalizedResponse =
        data && typeof data === 'object' && 'data' in data && data.data
          ? data.data
          : data
      return normalizedResponse as LoginResponse
    } catch (error) {
      logError(error, 'AuthService.login')
      throw normalizeError(error)
    }
  }
}

export const authService = new AuthService()


